jQuery(document).on("ready", function ($) {
    var $ = jQuery;

    // Global settings.
    const global = {
        settings: {
            tracking: false,
            trackingNum: "919-578-3557",
            nonTrackingNum: "919-989-4000",
            regex: /[\-\.()\\s]/gi,
            tel: $("a[href*=tel]"),
        },

        // Initialize the global settings.
        init: function () {
            // Check if this session needs to be tracked.
            const params = new URLSearchParams(window.location.search);
            if (params.get("src")) {
                this.settings.tracking = true;
                sessionStorage.setItem("tracking", this.settings.tracking);
            }

            // Check if this session is tracking.
            if (sessionStorage.getItem("tracking")) {
                this.settings.tracking = true;
            }

            // Bind events if tel links are found.
            if (this.settings.tel.length > 0) {
                this.bindUIEvents();
            }
        },

        // Bind events to the UI.
        bindUIEvents: function () {
            // Bind click events to the tel links.
            this.settings.tel.on("click", this.handleTelClicks);

            // Change the tel numbers to the tracking numbers if tracking is enabled.
            if (this.settings.tracking) {
                this.handleTrackingNumberChange();
            }
        },

        // Handle changing out the phone numbers.
        handleTrackingNumberChange: function () {
            // Set base number for tracking.
            const baseNonTrackingNum = this.settings.nonTrackingNum.replace(
                global.settings.regex,
                ""
            );

            // Loop through the tel links.
            global.settings.tel.each(function () {
                // Change the href attr to the tracking number.
                const baseOriginalHref = $(this)
                    .attr("href")
                    .replace(global.settings.regex, "")
                    .replace("tel:", "");

                if (baseOriginalHref.includes(baseNonTrackingNum)) {
                    $(this).attr(
                        "href",
                        $(this)
                            .attr("href")
                            .replace(
                                baseOriginalHref,
                                global.settings.trackingNum
                            )
                            .replace(
                                global.settings.nonTrackingNum,
                                global.settings.trackingNum
                            )
                    );
                }

                // Change the text to the tracking number.
                let originalHTML = $(this).html();

                // Carefully replace the text only while leaving any other markup intact.
                $(this).html(
                    originalHTML.replace(
                        global.settings.nonTrackingNum,
                        global.settings.trackingNum
                    )
                );
            });
        },

        // Handle the tel clicks.
        handleTelClicks: function () {
            // GTAG callback function.
            var callback = function () {
                if (typeof url != "undefined") {
                    window.location = url;
                }
            };

            // Add event conversion to GTAG.
            gtag("event", "conversion", {
                send_to: "AW-993057228/vDh6CMjC0oIDEMyzw9kD",
                event_callback: callback,
            });
        },
    };
    // Run the global settings.
    global.init();

    // Form handler.
    const contact_form = {
        settings: {
            form: $("#gform_2"),
        },

        init: function () {
            if (this.settings.form.length > 0) {
                this.updateSource();
            }
        },

        updateSource: function () {
            const sourceField = contact_form.settings.form.find("#input_2_6");
            const source = new URLSearchParams(window.location.search).get(
                "src"
            );

            if (source) {
                switch (source) {
                    case "g":
                        sourceField.val("Paid Search ");
                        break;
                    default:
                        sourceField.val("Paid Search ");
                        break;
                }
            } else {
                sourceField.val("Organic ");
            }
        },
    };
    contact_form.init();
});
